export default (function () {
    const closeFilters = {
        initMobile() {
            $(document).on('click', '.js--filters_close', () => {
                $('.js--mob_sort').removeClass('show');
                $('.sidebar_category').removeClass('show');
                $('.sidebar .PM_ASBlockOutput').removeClass('show');
                $('body').removeClass('overlay_bg_dark');
            });
        },
    };
    $(document).ready(() => {
        closeFilters.initMobile();
    });
}());
